export default function Equalizer({ active }) {
  return (
    <div className="flex items-end gap-[3px] h-5" data-testid="equalizer" aria-hidden>
      {[0, 1, 2, 3, 4].map((i) => (
        <span
          key={i}
          className={`eq-bar ${active ? "eq-on" : ""}`}
          style={{ animationDelay: `${i * 0.12}s` }}
        />
      ))}
    </div>
  );
}
